var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnswerNull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5819 7.96673C15.5819 11.878 12.4112 15.0487 8.49994 15.0487C4.58862 15.0487 1.41797 11.878 1.41797 7.96673C1.41797 4.05542 4.58862 0.884766 8.49994 0.884766C12.4112 0.884766 15.5819 4.05542 15.5819 7.96673Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7577 13.655C12.3805 13.7172 11.9932 13.7495 11.5983 13.7495C7.687 13.7495 4.51634 10.5788 4.51634 6.66748C4.51634 4.35434 5.62528 2.30024 7.34054 1.00781C3.98078 1.56108 1.41797 4.47889 1.41797 7.99536C1.41797 11.9067 4.58863 15.0773 8.49994 15.0773C10.0981 15.0773 11.5726 14.548 12.7577 13.655Z",
    fill: "#7D7D7D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.0286,
    height: 2.04466,
    rx: 1.02233,
    transform: "matrix(0.707107 -0.707106 0.707107 0.707106 4.27051 10.8545)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerNull);
export default __webpack_public_path__ + "static/media/answer_null.21256386530f9fcb0d9a502ce561e8e5.svg";
export { ForwardRef as ReactComponent };